import React from 'react';
import {
  Alert,
  Card,
  Col,
  Container,
  Row,
} from 'reactstrap';
import CCAutoPayCollPaymentForm from '../modules/paymentMethods/components/CCPaymentFormAutopay';

const AutoPayCollectionPage = () => {
  return (
    <section className="d-flex align-items-center "
             style={{marginTop: '200px'}}
    >
      <Container>
        <Alert color="info" className="text-center ">
          <h3>
            Please enter Credit / Debit card information
          </h3>
        </Alert>
        <Card className="border-0 rounded shadow mt-4">
          <Row>
            <Col lg={12}>
            </Col>
          </Row>
          <Col md={12}>
            <CCAutoPayCollPaymentForm/>
          </Col>
        </Card>
      </Container>
    </section>
  );
};

export default AutoPayCollectionPage;
